import api from "@/lib/api";

// Resolve a stored media URL to a loadable src.
export const mediaSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url; // e.g. /works/... served from public
};

// Upload a file to cloud storage (admin only). Returns a relative /api/media/... url.
export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
};
